export default {
  REQUIREMENTS: [
    {
      name: 'Mobile Native Unit',
      component_id: 'mobileNativeUnit',
      url_id: 'mobile_native_unit',
    },
    {
      name: 'Mobile Native Carousel',
      component_id: 'mobileNativeCarousel',
      url_id: 'mobile_native_carousel',
    },
    {
      name: 'Mobile Maxi Scroller',
      component_id: 'mobileMaxiScroller',
      url_id: 'mobile_maxi_scroller',
    },
    {
      name: 'Mobile Vertical Video',
      component_id: 'mobileVerticalVideo',
      url_id: 'mobile_vertical_video',
    },
    {
      name: 'Mobile Stories Banner',
      component_id: 'mobileStoriesBanner',
      url_id: 'mobile_stories_banner',
    },
    {
      name: 'Mobile Native Scroller',
      component_id: 'mobileNativeScroller',
      url_id: 'mobile_native_scroller',
    },
    {
      name: 'Mobile Benefit Banner',
      component_id: 'mobileBenefitBanner',
      url_id: 'mobile_benefit_banner',
    },
    {
      name: 'In-Read Video',
      component_id: 'inreadVideo',
      url_id: 'inread_video',
    },
    {
      name: 'Shoppable Ads',
      component_id: 'shoppableAds',
      url_id: 'shoppable_ads',
    },
    {
      name: 'Pre-roll',
      component_id: 'preroll',
      url_id: 'preroll',
    },
    {
      name: 'Pre-roll (Smart TV)',
      component_id: 'prerollSmartTV',
      url_id: 'preroll_smart_tv',
    },
    {
      name: 'Banner',
      component_id: 'banner',
      url_id: 'banner',
    },
    {
      name: 'In-Read Banner',
      component_id: 'inreadBanner',
      url_id: 'inread_banner',
    },
    {
      name: 'Pre-banner',
      component_id: 'preBanner',
      url_id: 'pre_banner',
    },
    {
      name: 'Cube Banner',
      component_id: 'cubeBanner',
      url_id: 'cube_banner',
    },
    {
      name: 'Динамический ретаргетинг (desktop)',
      component_id: 'dynamicRetarget',
      url_id: 'dynamic_retarget',
    },
    {
      name: 'In-Read Plus (desktop)',
      component_id: 'inreadPlusDesktop',
      url_id: 'inread_plus_desktop',
    },
    {
      name: 'BLS Banner',
      component_id: 'bls',
      url_id: 'bls',
    },
    {
      name: 'Реклама в ленте ВК',
      component_id: 'vkAds',
      url_id: 'vk_ads',
    },
    {
      name: 'Xiaomi Ads',
      component_id: 'xiaomiAds',
      url_id: 'xiaomi_ads',
    },
    {
      name: 'Adaptive Banner',
      component_id: 'adaptiveBanner',
      url_id: 'adaptive_banner',
      hidden: true,
    },
    {
      name: 'TGB Banners',
      component_id: 'tgbBanners',
      url_id: 'tgb_banners',
      hidden: true,
    },
    {
      name: 'Брендированная кнопка',
      component_id: 'brandButton',
      url_id: 'brand_button',
      hidden: true,
    },
    {
      name: 'Landing',
      component_id: 'landing',
      url_id: 'landing',
      hidden: true,
    },
    {
      name: 'In-Read Plus (mobile)',
      component_id: 'inreadPlusMobile',
      url_id: 'inread_plus_mobile',
      hidden: true,
    },
    {
      name: 'In-Read Max',
      component_id: 'inreadMax',
      url_id: 'inread_max',
      hidden: true,
    },
  ],
  INSTRUCTIONS: [
    {
      title: 'Код вставки',
      id: '#embed_code',
      active: false,
      opened: true,
      nested: [
        {
          title: 'Базовый код вставки',
          id: '#base_embed_code',
          active: false,
          opened: true,
          nested: [],
        },
        {
          title: 'Однокомпонентный код вставки',
          id: '#full_embed_code',
          active: false,
          opened: true,
          nested: [],
        },

        {
          title: 'Переход со старого кода вставки',
          id: '#migrate',
          active: false,
          opened: true,
          nested: [],
        },
      ],
    },
    {
      title: 'Компоненты',
      id: '#components',
      active: false,
      opened: true,
      nested: [
        {
          title: 'Параметры размещения',
          id: '#adunit',
          active: false,
          opened: true,
          nested: [
            {
              title: 'Корневой элемент',
              id: '#slot',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'placementId',
              id: '#placementid',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'placementHash',
              id: '#placementhash',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'sizes',
              id: '#sizes',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'onFetch',
              id: '#onfetch',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'onReady',
              id: '#onready',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'onError',
              id: '#onerror',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'onNoad',
              id: '#onnoad',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'onDestroy',
              id: '#ondestroy',
              active: false,
              opened: true,
              nested: [],
            },
          ],
        },
        {
          title: 'Библиотека',
          id: '#library',
          active: false,
          opened: true,
          nested: [
            {
              title: 'Подключение через внешнюю ссылку',
              id: '#library_tag',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'Загрузка внутри встроенного скрипта',
              id: '#library_load',
              active: false,
              opened: true,
              nested: [],
            },
          ],
        },
      ],
    },
    {
      title: 'Глобальные переменные',
      id: '#globals',
      active: false,
      opened: true,
      nested: [
        {
          title: 'buzzoolaAdUnits',
          id: '#buzzoolaadunits',
          active: false,
          opened: true,
          nested: [],
        },
        {
          title: 'buzzoolaAdSettings',
          id: '#buzzoolaadsettings',
          active: false,
          opened: true,
          nested: [
            {
              title: 'adUnitsDefaults',
              id: '#adunitsdefaults',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'adUnits',
              id: '#adunits',
              active: false,
              opened: true,
              nested: [],
            },
          ],
        },
      ],
    },
    {
      title: 'Заглушки',
      id: '#fallback',
      active: false,
      opened: true,
      nested: [
        {
          title: 'Добавление заглушки',
          id: '#add_fallback',
          active: false,
          opened: true,
          nested: [
            {
              title: 'AdFox',
              id: '#add_adfox',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'NativeRoll',
              id: '#add_nr',
              active: false,
              opened: true,
              nested: [],
            },
          ],
        },
        {
          title: 'Добавление в качестве заглушки',
          id: '#as_fallback',
          active: false,
          opened: true,
          nested: [
            {
              title: 'AdFox',
              id: '#add_adfox',
              active: false,
              opened: true,
              nested: [],
            },
            {
              title: 'NativeRoll',
              id: '#add_nr',
              active: false,
              opened: true,
              nested: [],
            },
          ],
        },
      ],
    },
  ],
};
